module.exports = __webpack_public_path__ + "static/img/ic_point.5549cfb4.png";